<template>
  <div class="footer__wrapper">
    <footer>
      <p v-html="footerText"></p>
      <a href="#header"><span class="back__to__top">Back to Top</span></a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      footerText: '&copy Manumech Engineering Ltd. ' + new Date().getFullYear(),
    }
  },
}
</script>

<style>
.footer__wrapper {
  background-color: #080515;
  
  color: white;
}

footer {
  text-align: center;
}

.back__to__top {
  font-size: 14px;
  color: lightgray;
}
</style>
